import { g as getNative, b as isPrototype, i as isArrayLike, c as arrayLikeKeys } from "./_arrayLikeKeys-44b287e6.js";
import { a as isObject } from "./isObject-ec23ace2.js";
function identity(value) {
  return value;
}
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}
var HOT_COUNT = 800, HOT_SPAN = 16, nativeNow = Date.now;
function shortOut(func) {
  var count = 0, lastCalled = 0;
  return function() {
    var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
    if (lastCalled = stamp, remaining > 0) {
      if (++count >= HOT_COUNT)
        return arguments[0];
    } else
      count = 0;
    return func.apply(void 0, arguments);
  };
}
function constant(value) {
  return function() {
    return value;
  };
}
var defineProperty = function() {
  try {
    var func = getNative(Object, "defineProperty");
    return func({}, "", {}), func;
  } catch {
  }
}();
const defineProperty$1 = defineProperty;
var baseSetToString = defineProperty$1 ? function(func, string) {
  return defineProperty$1(func, "toString", {
    configurable: !0,
    enumerable: !1,
    value: constant(string),
    writable: !0
  });
} : identity;
const baseSetToString$1 = baseSetToString;
var setToString = shortOut(baseSetToString$1);
const setToString$1 = setToString;
var nativeMax = Math.max;
function overRest(func, start, transform) {
  return start = nativeMax(start === void 0 ? func.length - 1 : start, 0), function() {
    for (var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length); ++index < length; )
      array[index] = args[start + index];
    index = -1;
    for (var otherArgs = Array(start + 1); ++index < start; )
      otherArgs[index] = args[index];
    return otherArgs[start] = transform(array), apply(func, this, otherArgs);
  };
}
function nativeKeysIn(object) {
  var result = [];
  if (object != null)
    for (var key in Object(object))
      result.push(key);
  return result;
}
var objectProto = Object.prototype, hasOwnProperty = objectProto.hasOwnProperty;
function baseKeysIn(object) {
  if (!isObject(object))
    return nativeKeysIn(object);
  var isProto = isPrototype(object), result = [];
  for (var key in object)
    key == "constructor" && (isProto || !hasOwnProperty.call(object, key)) || result.push(key);
  return result;
}
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, !0) : baseKeysIn(object);
}
export {
  defineProperty$1 as d,
  identity as i,
  keysIn as k,
  overRest as o,
  setToString$1 as s
};
//# sourceMappingURL=keysIn-f10bd97a.js.map
